export default __webpack_public_path__ + "static/media/frango-screenshot-02.48ccb7d9.png";